<template>
    <div 
        id="div_spAnnotations"
        ref="div_spAnnotations"
        class="novo-anotacoes-container"
    >
        <section class="novo-anotacoes-header">
            <ToothIconSvg width="24" height="24" class="novo-anotacoes-header-logo"/>
            <h3 class="novo-anotacoes-header-title">Anotações</h3>

        </section>

        <section class="novo-anotacoes-content">
            <rootNodeCMP v-for="(node, index) in GET_rootNodes" :key="node.id"
                :node="node"
                :execMode="'work'"
                :id="node.id"
                :activeNode="node.id == activeNode?.step ? activeNode : null"
                :orderNumber="index + 1"
            ></rootNodeCMP>
        </section>

    </div>
</template>

// =========================================================================================
// =========================================================================================

<script>
import _ from 'lodash';
import rootNodeCMP from './nodes/rootNode.vue';
import { gConsts } from '@/globals/gConsts';
import { evtBus  } from '@/main';
import { nodes   } from '@/globals/nodes';
import { mapGetters, mapState, mapActions } from 'vuex';

import ToothIconSvg from '@/assets/icons/tooth.svg';


export default {
    name : 'relatorioDinamicoCMP',
    components: {
        // nodeCMP,
        rootNodeCMP,
        ToothIconSvg,
    },

    // -----------------------------------------------------------------
    // -----------------------------------------------------------------

    props: {
        active  : Boolean,
        label   : String,
        panelId : String,
    }, 

    // -----------------------------------------------------------------
    // -----------------------------------------------------------------

    data() {
        return {
            gConsts: gConsts,
//            mouseInPanel : false
            activeNode: {
                step: null,
                layer: null,
                label: null,
            },
        };
    },

    // -----------------------------------------------------------------
    // -----------------------------------------------------------------
    
    computed: {
        ...mapState([
        ]),

        ...mapGetters([
            'GET_rootNodes',
            'GET_nodeSearchStr',
            'GET_togglesNodeSearch',
            'GET_filteredNodes',
        ]),

    },

    // -----------------------------------------------------------------
    // -----------------------------------------------------------------

    watch: {
        // Quando os filtered nodes mudam, tenho que selecionar o 1o step novamente
        GET_filteredNodes(newFilteredNodes) {
            let firstRootNode = (this.GET_rootNodes.length > 0) 
                ? this.GET_rootNodes[0] 
                : null;

            if ((!this.GET_nodeSearchStr.trim()) || (firstRootNode == null)) {
                return;
            } else {
                evtBus.$emit('evt_relatorioDinamico_activateNode', { nodeId: firstRootNode.id, nodeType: gConsts.node.layout.types.STEP });
            }
        },

        // -----------------------------------------------------------------

        // mouseInPanel() {
        //     console.log((this.mouseInPanel ? 'annotations_mouseEnter' : 'annotations_mouseLeave'));
        // },

        // -----------------------------------------------------------------
        
        active(newVal, oldVal) {
            console.log(`[activeChange] activeSp: ${this.active}, mInPanel: ${this.mouseInPanel}, nSStr: ${this.GET_nodeSearchStr}, nSActive: ${this.GET_togglesNodeSearch} `);

            /* Na ativação [this.active]/[newVal == true] olho se o mouse está sobre o painel 
                   e disparo o timer de colapso caso não esteja. */
            if (this.active) {
                if (!this.mouseInPanel) {
                    this.$parent.spsLeave(gConsts.ui.sidePanel.timeouts.SEARCH_COLLAPSE);
                }
            // Na desativação, desligo reseto o nodeSearch se estiver ativo
            } else {
                if (this.GET_togglesNodeSearch) {
                    this.ACT_uiUpdate({ 
                        sidePanels : { nodeSearchStr : ''    },
                        toggles    : { nodeSearch    : false }
                    });
                }            
            }

//            console.log(`[evt_nodeSearchAction|after(deactivation)] spActive: ${this.active}, mInPanel: ${this.mouseInPanel}, nSStr: ${this.GET_nodeSearchStr}, nSActive: ${this.GET_togglesNodeSearch} `);
        }
    },

    // -----------------------------------------------------------------
    // -----------------------------------------------------------------

    methods: {
        ...mapActions([
            'ACT_uiUpdate',
            'ACT_runtimeUpdate'
        ]),

        mouseInPanel() {
            var spBBox = this.$refs.div_spRelatorioDinamico.getBoundingClientRect();
                 
            return ( (spBBox.left   < this.GET_mov_mousePos.x) &&
                     (spBBox.right  > this.GET_mov_mousePos.x) &&
                     (spBBox.top    < this.GET_mov_mousePos.y) &&
                     (spBBox.bottom > this.GET_mov_mousePos.y) );
        },

        // -----------------------------------------------------------------        

        handleNodeSearchAction(action, newSearchStr, wa) {
            var panelState_payload,
                nodeSearchState_payload,
                merged_payload;

                panelState_payload      = this.nodeSearchActions_panelState(action, wa);                 // gerencia o state do painel de acordo com a nodeSearch action.
                nodeSearchState_payload = this.nodeSearchActions_nodeSearchState(action, newSearchStr);  // gerencia o state do nodeSearch de acordo com as nodeSearch action.

                merged_payload = _.merge({}, panelState_payload, nodeSearchState_payload);

                if (Object.keys(merged_payload).length > 0) {
                    this.ACT_uiUpdate(merged_payload);  // Executa a mudanca de estado se houver.
                }
        },

        // -----------------------------------------------------------------        

        /* Deals with the annotations panel state during nodeSearch actions.
               OBS: inserting the appropriate values in the payload it receives as parameter.
               - prevents collapse if active (except on a DISABLE)  
               - expands/activates, and changes sides for INPUT and LOCATION_FILTER
               - deactivates on DISABLE */
        nodeSearchActions_panelState(action, wa) {
            var waBBox, panelSide,
                payload = {}; 

            switch (action) {
                case gConsts.node.search.actions.LOCATION_FILTER :
                case gConsts.node.search.actions.INPUT           : 
                case gConsts.node.search.actions.NAV_NEXT        :
                case gConsts.node.search.actions.NAV_PREV        :
                    if (this.active) {                    
                        if (!this.mouseInPanel) {
                            // Se houve [evt_nodeSearchAction], mesmo com o mouse fora do sPanel, ele deve continuar ativo 
                            this.$parent.spsResetCollapse(gConsts.ui.sidePanel.timeouts.SEARCH_COLLAPSE);
                        }
                    } else {
                        // Especificamente para INPUT e LOCATION_FILTER, se o sPanel não está ativo, devemos ativá-lo
                        switch (action) {
                            case gConsts.node.search.actions.LOCATION_FILTER :
                            case gConsts.node.search.actions.INPUT           :                                 
                                // Muda o lado do painel se ele estiver se ele for ficar sobre o mouse quando expandir
                                waBBox = wa.getBoundingClientRect(),
                                panelSide = ((waBBox.width/2) < this.GET_mov_mousePos.x) ? gConsts.ui.sidePanel.sides.LEFT : gConsts.ui.sidePanel.sides.RIGHT;

                                payload['sidePanels'] = { 
                                    activeSp    : this.panelId,
                                    spAnnotSide : panelSide
                                };
//                                console.log(`mouse pos [x/y] : [${this.GET_mov_mousePos.x} / ${this.GET_mov_mousePos.y}]`);
                                break;
                        }
                    }
                    break;
                
                case gConsts.node.search.actions.DISABLE :
                    /* Aqui eu só desativo o painel e deixo pro [watch.active] resetar o nodeSearch state
                           - [ui.sidePanels.nodeSearchStr = ''] e [ui.toggles.nodeSearch = false].
                       Centralizo no watch pois este reset tb acontece com [sidePanels.spsLeave] */
                    payload['sidePanels'] = { activeSp : '' };
                    break;
            }

            return payload;
        },

        // -----------------------------------------------------------------        

        /* Deals with the nodeSearch state during nodeSearch events/actions.
               OBS: inserting the appropriate values in the payload it receives as parameter.
               - toggles nodeSearch on INPUT and LOCATION_FILTER;
               - updates nodesSearchStr on INPUT;
               - performs node navigagion on NAV_NEXT and NAV_PREV
               - deactivates on DISABLE. */
        nodeSearchActions_nodeSearchState(action, newSearchStr) {
            var payload = {}; 

            switch (action) {
                case gConsts.node.search.actions.LOCATION_FILTER :
                case gConsts.node.search.actions.INPUT           : 
                    if (!this.GET_togglesNodeSearch) {
                        payload['toggles'] = { nodeSearch : true }
                    }

                    if ( (action == gConsts.node.search.actions.INPUT) && 
                         (newSearchStr != this.GET_nodeSearchStr     ) ) {
                        payload.sidePanels = payload.sidePanels ?? {};
                        payload.sidePanels.nodeSearchStr = newSearchStr;
                    }
                    break;
                case gConsts.node.search.actions.NAV_NEXT : nodes.labelNav(gConsts.ui.shortcuts.NEXT); break;
                case gConsts.node.search.actions.NAV_PREV : nodes.labelNav(gConsts.ui.shortcuts.PREV); break;              
            }

            return payload;
        },

        handleActivateNode(payload) {
            var rootNode, layerNode, firstLabelNode;
            console.log('relatorioDinamico.handleActivateNode', payload);
            if (payload.nodeId == null || payload.nodeType == null)
                return;

            var newActiveNode = this.GET_filteredNodes.find(node => node.id == payload.nodeId);

            if (!newActiveNode)
                return;

            // console.log('relatorioDinamico.handleActivateNode.newActiveNode: ', newActiveNode);

            switch (payload.nodeType) {
                case gConsts.node.layout.types.LABEL :
                    if (newActiveNode.id == this.activeNode.label) {
                        this.activeNode.label = null;
                    } else {
                        layerNode = this.GET_filteredNodes.find(node => node.id == newActiveNode.layout.parent);
                        rootNode = this.GET_rootNodes.find(node => node.id == layerNode.layout.parent);
                        this.activeNode = {
                            step: rootNode.id,
                            layer: layerNode.id,
                            label: newActiveNode.id,
                        };
                    }
                    break;
                case gConsts.node.layout.types.LAYER :
                    if (newActiveNode.id == this.activeNode.layer) {
                        this.activeNode.layer = null;
                        this.activeNode.label = null;
                    } else {
                        rootNode = this.GET_rootNodes.find(node => node.id == newActiveNode.layout.parent);
                        firstLabelNode = this.GET_filteredNodes.find(node => node.layout.parent == newActiveNode.id)?.[0] ?? null;
                        this.activeNode = {
                            step: rootNode.id,
                            layer: newActiveNode.id,
                            label: firstLabelNode?.id ?? null,
                        };
                    }
                    break;
                case gConsts.node.layout.types.STEP :
                    if (newActiveNode.id == this.activeNode.step) {
                        this.activeNode.step = null;
                        this.activeNode.layer = null;
                        this.activeNode.label = null;
                    } else {
                        var layerId = null;
                        if (newActiveNode.id == 'step_denticao') {
                            layerId = 'layer_dentesSeg';
                        }

                        this.activeNode = {
                            step: newActiveNode.id,
                            layer: layerId,
                            label: null,
                        };
                    }
                    break;
            }

            this.ACT_runtimeUpdate({ active : this.activeNode });
            evtBus.$emit('evt_activateNode', this.activeNode);
        },
    },

    // -----------------------------------------------------------------        

    mounted() {
    },

    // -----------------------------------------------------------------        
    
    created() {
        evtBus.$on('evt_relatorioDinamico_activateNode', this.handleActivateNode);

        evtBus.$on('evt_nodeSearchAction', this.handleNodeSearchAction);
    }

    // -----------------------------------------------------------------

};
</script>

// =========================================================================================
// =========================================================================================

<style>

.novo-anotacoes-container {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 15px;
    cursor: default;
}

.novo-anotacoes-header {
    display: flex;
    align-items: center;
    gap: 10px;
    padding-bottom: 10px;
    border-bottom: 1px solid #ccc;
}

.novo-anotacoes-header-button {
    margin-left: auto;
    appearance: none;
    border: none;
    outline: none;
    display: flex;
    align-items: center;
    gap: 5px;
    padding: 5px 10px;
    border-radius: 4px;
    background-color: #F3F4F6;
    font-family: var(--font-family-primary);
    font-size: var(--text-sm);
    font-weight: 500;
    color: #4B5563;
    transition: all 0.2s ease;
    cursor: pointer;
}

.novo-anotacoes-header-button:not([data-is-active="true"]):hover {
    background-color: #37415122;
}

.novo-anotacoes-header-button[data-is-active="true"] {
    background-color: #374151;
    color: #FFFFFF;
}

.novo-anotacoes-header-button[data-is-active="true"]:hover {
    background-color: #374151dd;
}

.novo-anotacoes-content {
    display: flex;
    flex-direction: column;
    gap: 10px;
    overflow-y: auto;
    height: 100%;
    max-height: 70vh;
    /* Firefox scrollbar styling */
    scrollbar-width: thin;
    scrollbar-color: #374151 transparent;
}

/* Webkit scrollbar styling */
.novo-anotacoes-content::-webkit-scrollbar {
    width: 8px;
}

.novo-anotacoes-content::-webkit-scrollbar-track {
    background: transparent;
}

.novo-anotacoes-content::-webkit-scrollbar-thumb {
    background: #374151;
    border-radius: 4px;
}

.novo-anotacoes-content::-webkit-scrollbar-thumb:hover {
    background: #374151;
}

.novo-anotacoes-header-title {
    margin: 0;
    padding: 0;
    font-family: var(--font-family-primary);
    font-size: 20px;
    font-weight: 700;
    color: #2B536A;
}

.ulMain {
    list-style: none;
    padding-left:0px;
    margin-top: 0px;
    position: relative;
    height: 100%;
    top: 0px;
    left: 0px;
    overflow-y: scroll;
    overflow-x: hidden;
}

.nodeTransition-enter-active {
    transition: opacity 0.2s ease-in;
}

.nodeTransition-leave-active {
    transition: opacity 0s;
}

.nodeTransition-enter-to, .step-leave {
    opacity: 1;
}

.nodeTransition-enter, .nodeTransition-leave-to {
    opacity: 0;
}

</style>